import { axiosInstance as axios } from "./axiosInstance";

const API_URL = process.env.REACT_APP_URL;

const casetype = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseMaster/getCaseType`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const casesubtype = (ids) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseMaster/getAllCaseSubType/${ids.join(",")}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const allemployee = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/employee/allEmpDesig`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
};

const casestatus = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/35`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
};

const department = () => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/master/getAllMasterData/7`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
};

const employeeAccordingtodepartment = (department) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/employee/allEmpDesig`,
        {
            params: {
                department: department,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const b2bcaselist = (params = {}) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseM/caseListB2B`,
        {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2ccaselist = (params = {}) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.get(
        `${API_URL}/caseM/caseListB2C`,
        {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2bstatuschanges = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/changeStatusB2B`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2cstatuschanges = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/changeStatusB2C`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2bassignedemp = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/assingnEmployeeforb2b`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2cassignedemp = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");
    return axios.post(
        `${API_URL}/caseM/assingnEmployeeforb2c`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

const b2bexportexcel = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/exportCasesforb2b`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
        }
    );
};

const b2cexportexcel = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/exportCasesforb2c`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: "blob",
        }
    );
};

 const b2bactivitycase = (caseId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseM/getcaseforb2b?caseId=${caseId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const b2cactivitycase = (caseId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseM/getcaseforb2c?caseId=${caseId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const getNotifications = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseM/getnotification`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const deleteNotification = (notificationId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/deletenotications`,
        {
            notificationId
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const getCaseChat = (casesMId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(
        `${API_URL}/caseM/getCaseChat`,
        {
            params: {
                casesMId,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};
 

// const sendCaseChat = (payload) => {
//     const token = localStorage.getItem("_ux98c_v1");

//     return axios.post(
//         `${API_URL}/caseM/sendchatcase`,
//         payload,
//         {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//             },
//         }
//     );
// };

const sendCaseChat = (payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/sendchatcase`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const sendEmail = (caseId, payload) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/sendEmail?caseId=${caseId}`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const getCaseEmail = (caseId) => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(`${API_URL}/caseM/getCaseEmail`, {
    params: {
      caseId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const startCaseB2B = (caseId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/startCaseB2B`,
        { caseId },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const startCaseB2C = (caseId) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/startCaseB2C`,
        { caseId },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

// const getNextCaseStatuses = (caseId) => {
//     const token = localStorage.getItem("_ux98c_v1");

//     return axios.get(
//         `${API_URL}/caseM/getNextCaseStatuses/${caseId}`,
//         {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//             },
//         }
//     );
// };

const getNextCaseStatuses = (caseIds) => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.post(
        `${API_URL}/caseM/getNextCaseStatuses`,
        {
            caseIds: caseIds,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};


const getB2BCasesDashboard = (params = {}) => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(
    `${API_URL}/caseM/dashboardforb2b`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



export {
    casetype,
    casesubtype,
    allemployee,
    casestatus,
    department,
    employeeAccordingtodepartment,
    b2bcaselist,
    b2ccaselist,
    b2bstatuschanges,
    b2cstatuschanges,
    b2bassignedemp,
    b2cassignedemp,
    b2bexportexcel,
    b2cexportexcel,
    b2bactivitycase,
    b2cactivitycase,
    getNotifications,
    deleteNotification,
    getCaseChat,
    sendCaseChat,
    sendEmail,
    getCaseEmail,
    startCaseB2B,
    startCaseB2C,
    getNextCaseStatuses,
    getB2BCasesDashboard
};